module.exports = __webpack_public_path__ + "img/Road Bike Woman.c136022.svg";